import { mapActions } from 'vuex'

import { get } from 'lodash'

export const metaInfo = {
  metaInfo() {
    return {
      titleTemplate: titleChunk => {
        const result = [ get(this.globalSettings, 'frontend.title') ]

        if (titleChunk) {
          result.push(this.getTranslate(titleChunk))
        }

        return result.filter(v => {
          return !!v
        }).join(' | ')
      }
    }
  },

  watch: {
    globalSettings: {
      handler() {
        this.$meta().refresh()
        this.setFrontendColors()
      },
      deep: true
    }
  },

  async mounted() {
    await this.getGlobalSettings()
    this.setFrontendColors()
  },

  methods: {
    ...mapActions({ getGlobalSettings: 'settings/getGlobalSettings' }),

    setFrontendColors() {
      const root = document.documentElement

      let overrideColors = {}

      if (this.isPlatinum) {
        overrideColors = {
          primary: '#607D8B',
          accent: '#CFD8DC',
          secondary: '#904e95'
        }
      }

      const schemaColors = get(this.globalSettings, 'frontend.colors', {})
      for (const color in schemaColors) {
        root.style.setProperty(`--${color}`, overrideColors[color] || schemaColors[color])
      }
    }
  }
}
